import { render } from "./DataEdit.vue?vue&type=template&id=3c78b667"
import script from "./DataEdit.vue?vue&type=script&lang=js"
export * from "./DataEdit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Pages/DataEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c78b667"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c78b667', __exports__)) {
    console.log('reload')
    api.reload('3c78b667', __exports__)
  }
  
  module.hot.accept("./DataEdit.vue?vue&type=template&id=3c78b667", () => {
    console.log('re-render')
    api.rerender('3c78b667', render)
  })

}


export default __exports__